import { createTheme } from '@mui/material/styles';
import defaultTheme from './theme';

/**
 * Create a MUI theme from an app theme object.
 * Call this whenever the app theme changes (e.g. light -> dark).
 */
export const createMuiAppTheme = (appTheme) =>
  createTheme({
    palette: {
      mode: appTheme.mode === 'dark' ? 'dark' : 'light',
      background: {
        default: appTheme.colors.background.main,
        paper: appTheme.colors.background.modal,
      },
      text: {
        primary: appTheme.colors.text.primary,
        secondary: appTheme.colors.text.secondary,
      },
    },
    typography: {
      fontFamily: appTheme.fontFamily.primary,
      h1: { fontFamily: appTheme.fontFamily.primary },
      h2: { fontFamily: appTheme.fontFamily.primary },
      h3: { fontFamily: appTheme.fontFamily.primary },
      h4: { fontFamily: appTheme.fontFamily.primary },
      h5: { fontFamily: appTheme.fontFamily.primary },
      h6: { fontFamily: appTheme.fontFamily.primary },
      body1: { fontFamily: appTheme.fontFamily.primary },
      body2: { fontFamily: appTheme.fontFamily.primary },
      button: { fontFamily: appTheme.fontFamily.primary },
      caption: { fontFamily: appTheme.fontFamily.primary },
      overline: { fontFamily: appTheme.fontFamily.primary },
    },
    components: {
      MuiTableCell: {
        styleOverrides: { root: { fontFamily: appTheme.fontFamily.primary } },
      },
      MuiTypography: {
        styleOverrides: { root: { fontFamily: appTheme.fontFamily.primary } },
      },
      MuiButton: {
        styleOverrides: { root: { fontFamily: appTheme.fontFamily.primary } },
      },
      MuiChip: {
        styleOverrides: { root: { fontFamily: appTheme.fontFamily.primary } },
      },
      MuiTextField: {
        styleOverrides: { root: { fontFamily: appTheme.fontFamily.primary } },
      },
      MuiInputBase: {
        styleOverrides: { root: { fontFamily: appTheme.fontFamily.primary } },
      },
      MuiListItemText: {
        styleOverrides: {
          primary: { fontFamily: appTheme.fontFamily.primary },
          secondary: { fontFamily: appTheme.fontFamily.primary },
        },
      },
    },
  });

// Default static export for backward compatibility
const muiTheme = createMuiAppTheme(defaultTheme);
export default muiTheme;
